import React, { useEffect } from 'react';
import { DatePicker, Form, Row, Spin } from 'antd';
import DF from 'DisplayFramework';

import UtinaCard from 'components/UtinaCard';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import TextArea from 'antd/lib/input/TextArea';
import Value from 'components/Value';
import { getProposalById } from 'services/proposal';
import { useQuery } from 'react-query';
import { isNil } from 'lodash';
import RateFormulaSelect from 'components/RateFormulaSelect';
import InputRate from 'components/InputRate';

export const TabUpdateContractSignatureDate = ({
  objectid,
  form,
  setSuccessful,
}: any) => {
  const { data, refetch, isFetching } = useQuery(
    ['getProposalById', objectid],
    () => getProposalById({ ctrid: objectid }).then((res) => res.data),
    {
      enabled: !isNil(objectid),
      staleTime: 60 * 1000 * 5,
    }
  );

  useEffect(() => {
    if (data) {
      const elementsFin = data?.conElements.find((e) => e.ctetype === 'FIN');

      form.setFieldsValue({
        status: data.ctstatuslabel,
        phase: data.ctphaselabel,
        prefinmethod: elementsFin!.prefinmethod,
        prefinbasis: elementsFin!.prefinbasis,
        prefinperiodicity: elementsFin!.prefinperiodicity,
        prefinnominalrate: elementsFin!.prefinnominalrate,
        prefinrateformula: elementsFin!.prefinrateformula,
        prefinratetype: elementsFin!.prefinratetype,
        ctrequestdate: data.ctrequestdate,
        ctinitstartdate: data.ctinitstartdate,
        ctdurationmonths: data.ctdurationmonths,
        ctinitenddate: data.ctinitenddate,
        ctacceptancedate: data.ctdecisiondate,
      });
    }
  }, [data]);

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);
  return (
    <DF.Provider pagcode="tabUpdateCTSignatureDate">
      <Spin spinning={isFetching}>
        <Form form={form} layout="vertical" labelAlign="left">
          <UtinaCard
            style={{ height: '100%' }}
            level={5}
            lg={24}
            comcode="tabUpdateCTSignatureDate"
            styleCard={{
              paddingRight: 10,
            }}
          >
            <Row gutter={30}>
              <FormInput col md={6} name="phase">
                <Value />
              </FormInput>

              <FormInput col md={6} name="status">
                <Value />
              </FormInput>
            </Row>
            <Row gutter={30}>
              <FormInput col md={6} name="ctrequestdate">
                <Value />
              </FormInput>

              <FormInput col md={6} name="ctinitstartdate">
                <Value />
              </FormInput>
              <FormInput col md={6} name="ctdurationmonths">
                <Value />
              </FormInput>

              <FormInput col md={6} name="ctinitenddate">
                <Value />
              </FormInput>

              <FormInput col md={6} name="ctacceptancedate">
                <Value />
              </FormInput>

              <FormInput col md={6} name="signaturedate">
                <DatePicker />
              </FormInput>

              <FormInput col md={6} name="mandatedate">
                <DatePicker />
              </FormInput>
            </Row>

            <Row gutter={30}>
              <FormInput col md={6} name="reason">
                <ParListSelect parcode="" />
              </FormInput>

              <FormInput labelCol={{ span: 5 }} col md={12} name="comment">
                <TextArea rows={4} />
              </FormInput>
            </Row>
          </UtinaCard>

          <UtinaCard
            style={{ height: '100%' }}
            level={5}
            lg={24}
            comcode="prefin"
            styleCard={{
              paddingRight: 10,
            }}
          >
            <Row gutter={30}>
              <FormInput col md={8} name="prefinmethod">
                <ParListSelect
                  parcode="PREFINMET"
                  // parvalueparent={getFieldValue('prefinmethod')}
                />
              </FormInput>

              <FormInput col md={8} name="prefinbasis">
                <ParListSelect parcode="PREFINBAS" />
              </FormInput>
              <FormInput col md={8} name="prefinperiodicity">
                <ParListSelect parcode="PREFINPER" />
              </FormInput>

              <FormInput col md={8} name="prefinratetype">
                <ParListSelect parcode="RATETYPE" />
              </FormInput>
              <FormInput col md={8} name="prefinrateformula">
                <RateFormulaSelect
                  params={{
                    formulatype: form.getFieldValue('prefinratetype'),
                  }}
                />
              </FormInput>

              <FormInput col xs={4} name="prefinratespread">
                <InputRate />
              </FormInput>

              <FormInput col md={4} name="prefinnominalrate">
                <InputRate />
              </FormInput>
            </Row>
          </UtinaCard>
        </Form>
      </Spin>
    </DF.Provider>
  );
};
